// Universal modal styles for all dialogs
export const universalModalPaperProps = {
  sx: {
    background: 'rgb(255, 255, 255)', // Sea glass translucent background with better contrast
    backdropFilter: 'blur(10px)', // Frosted glass effect
    WebkitBackdropFilter: 'blur(10px)', // Safari support
    border: 'none',
    borderRadius: '20px', // Rounded corners - adjust this value to make more/less rounded
    boxShadow: '0 8px 32px rgba(70, 84, 106, 0.32)', // Sea glass shadow
    color: '#f8f9fa', // Off-white text
    '& .MuiDialogTitle-root': {
      fontSize: '2rem', // Larger title font size (default is around 1.25rem)
      fontWeight: 400, // Slightly bolder
      color: 'rgba(38, 38, 38, 0.85)', // Slightly darker for better contrast
      paddingBottom: '1px', // Add some bottom padding
    },
    '& .MuiTypography-root': {
      color: 'rgba(38, 38, 38, 0.7)', // Off-white for all typography
    },
    '& .MuiInputLabel-root': {
      color: 'rgba(72, 74, 75, 0.7)', // Off-white for input labels
    },
    '& .MuiOutlinedInput-root': {
      color: 'rgb(62, 62, 63)', // Off-white for input text
      '& fieldset': {
        borderColor: 'rgba(22, 69, 116, 0.84)', 
      },
      '&:hover fieldset': {
        borderColor: 'rgba(13, 81, 149, 0.84)', 
      },
    },
  }
};

export const universalModalBackdropProps = {
  style: {
    backgroundColor: 'rgba(80, 80, 80, 0.32)',
    backdropFilter: 'blur(2px)', // Frosted glass effect
    WebkitBackdropFilter: 'blur(2px)', // Safari support // Remove dark overlay
  }
}; 